<template>
  <div class="row">
    <div class="col_12">
      <div class="card no_border">
        <div class="card-header">
          <div class="card-title">랜딩페이지관리</div>
        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row">
            <div class="col_2">
              <div class="form-group">
                <label></label>
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>{{ filter2.status }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="changeStatusFilter('all')">
                          <a role="button">{{ $t('common.all') }}</a>
                        </li>
                        <li @click="changeStatusFilter('active')">
                          <a role="button">{{ $t('common.active') }}</a>
                        </li>
                        <li @click="changeStatusFilter('inactive')">
                          <a role="button">{{ $t('common.inactive') }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_10">
              <div class="form-group">
                <label></label>
                <div class="d_flex_end">
                  <div class="form_row_inline ml_10">
                    <input
                      type="text"
                      class="form_global"
                      :placeholder="$t('common.search')"
                      v-model="queryParams.search"
                    />
                  </div>
                  <div class="form_row_inline ml_10">
                    <div
                      class="btn btn_common_type_2 width_150p"
                      @click="
                        queryParams.page = 1;
                        searchQuery();
                      "
                    >
                      {{ $t('common.search') }}
                    </div>
                  </div>
                  <div class="form_row_inline ml_10">
                    <div
                      class="btn btn_common_type_2 width_150p"
                      @click="resetAll()"
                    >
                      {{ $t('common.reset') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_12">
              <div class="separator pl_0 pr_0">
                <span></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_12">
              <div class="d_flex_btwn pt_20 pb_20">
                <div class="d_flex_start col_2 pl_0">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>{{ filter.per_page }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="changePerPageFilter(10)">
                          <a role="button">10</a>
                        </li>
                        <li @click="changePerPageFilter(20)">
                          <a role="button">20</a>
                        </li>
                        <li @click="changePerPageFilter(50)">
                          <a role="button">50</a>
                        </li>
                        <li @click="changePerPageFilter(100)">
                          <a role="button">100</a>
                        </li>
                        <li @click="changePerPageFilter(200)">
                          <a role="button">200</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="d_flex_end col_6 pr_0">
                  <router-link
                    :to="{ name: 'landing_page_add' }"
                    class="btn btn_transparent"
                    >만들기
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <table-component
            :columns="columns"
            :rows="landing_pages"
            :pagination="pagination"
            @sorting="sorting"
            :sortable="sortable"
            @pageChanged="pageChanged"
          >
            <template #page_url="{ row }">
              <td>
                <button
                  class="btn btn_blue"
                  title="미리보기"
                  @click.prevent="pagePreview(row)"
                >
                  미리보기
                </button>
              </td>
            </template>
            <template #action="{ row }">
              <div class="d_flex_center table_action_btn">
                <button
                  v-if="row.status == 1"
                  class="btn btn_danger ml_10"
                  title="비활성화"
                  @click.prevent="changeStatus(row)"
                >
                  <img
                    :src="`${baseUrl}assets/media/images/icon/x.png`"
                    alt=""
                  />
                </button>
                <button
                  v-else
                  class="btn btn_info ml_10"
                  title="활성화"
                  @click.prevent="changeStatus(row)"
                >
                  <img
                    :src="`${baseUrl}assets/media/images/icon/v.png`"
                    alt=""
                  />
                </button>
                <router-link
                  :to="{ name: 'landing_page_edit', params: { id: row.id } }"
                  :title="$t('common.edit')"
                  class="btn btn_blue ml_10"
                >
                  <img
                    :src="`${baseUrl}assets/media/images/icon/8.png`"
                    alt=""
                  />
                </router-link>
                <button
                  class="btn btn_danger ml_10"
                  :title="$t('common.delete')"
                  @click.prevent="deleteRecord(row)"
                >
                  <img
                    :src="`${baseUrl}assets/media/images/icon/9.png`"
                    alt=""
                  />
                </button>
              </div>
            </template>
          </table-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from '@/components/shared/TableComponent';

export default {
  components: { TableComponent },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      landing_pages: [],
      filter: {
        status: 'all',
        per_page: 20,
      },
      filter2: {
        status: this.$t('common.all'),
        per_page: 20,
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'title,page_url',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20,
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc',
      },
      columns: [
        {
          label: '제목',
          field: 'title',
          sortable: true,
        },
        {
          label: '',
          field: 'page_url',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('common.action'),
          field: 'action',
          sortable: false,
          slot: true,
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams());
        this.loadData();
      }
    },
  },
  created() {
    const query = this.getAllQueryParams();
    if (query.page) {
      this.setQueryData(query);
    }

    this.loadData();
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page,
      };

      this.filter = {
        status: query.status,
        per_page: query.per_page,
      };
      this.sortable = {
        order: query.sort,
        sort: query.sort_order,
      };
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc',
      };
      this.filter = {
        status: 'all',
        per_page: 20,
      };
      this.filter2 = {
        status: this.$t('common.all'),
        per_page: 20,
      };

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'title,page_url',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20,
      };

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({ column, order }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute();
    },
    changePerPageFilter(per_page) {
      this.filter.per_page = per_page;
      this.changeRoute();
    },
    changeStatusFilter(status) {
      this.filter.status = status;
      this.filter2.status = this.$t(status);
      this.changeRoute();
    },
    changeRoute() {
      this.$router.push({
        name: this.$route.name,
        query: { ...this.queryParams, ...this.filter },
      });
    },
    loadData() {
      this.axios
        .get('/landing-pages', {
          params: { ...this.queryParams, ...this.filter },
        })
        .then((response) => {
          this.landing_pages = response.data.data;
          this.pagination = response.data.meta;
        });
    },
    pagePreview(row) {
      if (row.page_url) {
        window.open(
          process.env.VUE_APP_FRONT_URL + '/' + row.page_url,
          '_blank'
        );
      } else {
        alert('페이지 URL이 없습니다.');
      }
    },
    changeStatus(row) {
      this.$swal({
        title: '상태를 변경하시겠습니까?',
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#00B4FF',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.post('/change-landing-page-status/' + row.id).then(() => {
            this.loadData();
            this.showSuccessMsg('상태가 업데이트되었습니다.');
          });
        }
      });
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/landing-pages/' + row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.deleted'),
              this.$t('common.deleteMessage'),
              'success'
            );
          });
        }
      });
    },
  },
};
</script>
